import React from "react";
import {
  useMemberstackModal,
  ModalMethods,
  SignupModalProps,
  LoginModalProps,
  ProfileModalProps,
  ForgotModalProps,
} from "../hooks/useMemberstackModal";

export interface ModalType {
  type: "LOGIN" | "SIGNUP" | "FORGOT_PASSWORD" | "PROFILE";
}

const modalFactory = ({ type }: ModalType) => {
  return function ModalComponent(
    props: (LoginModalProps | SignupModalProps | ProfileModalProps | ForgotModalProps) &
      ModalMethods
  ) {
    const { openModal } = useMemberstackModal();
    React.useEffect(() => {
      openModal({
        type,
        planId: (props as LoginModalProps | SignupModalProps).planId,
        priceId: (props as LoginModalProps | SignupModalProps).priceId,
        onCompleted: props.onCompleted,
        onError: props.onError,
      });
    }, []);

    return null;
  };
};

export const SignInModal = modalFactory({ type: "LOGIN" });
export const SignUpModal = modalFactory({ type: "SIGNUP" });
export const ProfileModal = modalFactory({ type: "PROFILE" });
